export default __webpack_public_path__ + "static/media/Mask of Bristling Ire.bf384cff.jpg";